import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import image1 from '../../images/js.webp';
import image2 from '../../images/react sj.png';
import image3 from '../../images/stack-icon3.webp';
import image4 from '../../images/stack-icon4.webp';
import image5 from '../../images/stack-icon5.webp';
import image6 from '../../images/stack-icon6.webp';
import image7 from '../../images/stack-icon7.webp';
import image8 from '../../images/stack-icon8.webp';

const techIcons = [
  { src: image1, alt: 'JavaScript' },
  { src: image2, alt: 'React' },
  { src: image3, alt: 'Rails' },
  { src: image4, alt: 'Python' },
  { src: image5, alt: 'Node.js' },
  { src: image6, alt: 'Drupal' },
  { src: image7, alt: 'WordPress' },
  { src: image8, alt: 'Magento' }
];

// Keyframes for the floating effect on icons
const floatAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0);
  }
`;

// Keyframes for the rotate and zoom effect on hover
const hoverAnimation = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
  }
  50% {
    transform: scale(1.1) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
`;

const Image = styled('img')({
  width: '50px',
  height: '50px',
  objectFit: 'contain',
});

const CircleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '120px',
  height: '120px',
  borderRadius: '50%',
  backgroundColor: '#fff',
  boxShadow: '0 6px 15px rgba(0, 0, 0, 0.15)',
  animation: `${floatAnimation} 4s ease-in-out infinite`,
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  '&:hover': {
    animation: `${hoverAnimation} 0.6s ease-in-out`,
    boxShadow: '0 12px 30px rgba(35, 48, 152, 0.6)',
    transform: 'scale(1.2)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100px',
    height: '100px',
  },
}));

const SectionBackground = styled(Box)({
  // background: 'linear-gradient(45deg, #6a11cb, #2575fc)',
  padding: '50px 0',
  borderRadius: '10px',
});

const Technologies = () => {
  return (
    <SectionBackground>
      <Container sx={{ maxWidth: 'lg' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            color: 'black',
            mb: 5,
            textAlign: 'center',
            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
            textTransform: 'uppercase',
            fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
          }}
        >
          Technologies Used
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {techIcons.map((icon, index) => (
            <Grid item key={index} xs={6} sm={3} md={1.5} display="flex" justifyContent="center">
              <CircleBox>
                <Image src={icon.src} alt={icon.alt} />
              </CircleBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </SectionBackground>
  );
};

export default Technologies;
